import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
var DataClass = /*#__PURE__*/_createClass(function DataClass(props) {
  var _this = this;
  _classCallCheck(this, DataClass);
  _defineProperty(this, "log", function () {
    console.log(_this.data);
  });
  _defineProperty(this, "debug", function () {
    console.debug(_this);
  });
  _defineProperty(this, "getHTML", function (html) {
    try {
      html = html.replace(/amp;/g, '');
      html = html.replace(/amp;wd/g, '');
      html = html.replace(/&lt;/g, '<');
      html = html.replace(/&gt;/g, '>');
      html = html.replace(/\<\/b\>/ig, ' </b>');
      html = html.replace(/\<\/i\>/ig, ' </i>');
      html = html.replace(/\<\/a\>/ig, ' </a>');
      html = html.replace(/\<\/p\>/ig, ' </p>');
    } catch (error) {
      html = html;
    }
    return html;
  });
  this.data = props;
});
export default DataClass;